import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'dateFormat' })
export class MomentPipe implements PipeTransform {
  transform(value: Date | moment.Moment, dateFormat: string): any {
    moment.updateLocale('fr', {
      relativeTime: {
        mm: '%d min',
        s: '%d sec',
        m: '%d min',
        h: '%d heure',
        d: '%d jour',
        //w:  "%d semaine",
        M: '%d mois',
        y: '%d année'
      }
    });
    moment.locale('fr');
    return moment(value).fromNow(true);
  }
}
